<template>
  <div class="LianLianPayViewContainer">
    <nut-row class="bothCenter vpd50">
      <img src="https://cdn.waityou.online/5e21626f-e360-ed49-4b0c-4229bbbf675d.svg"
           style="width: 100px"/>
    </nut-row>
    <nut-row class="bothCenter" style="background: rgba(245,244,236,0.34)">
      <nut-col :span="6" class="leftCenter">
        <img src="https://cdn.waityou.online/0dd94df8-f8fe-1716-59b6-a821a464f227.svg"
             class="sqr70"/>
      </nut-col>
      <nut-col :span="18" class="colFlex">
        <span class="ft20 boldFont">¥{{ order.amt ? (order.amt / 100.0).toFixed(2) : '-' }}</span>
        <span class="ft14 lightText">{{ order.goodName }}</span>
      </nut-col>
    </nut-row>
    <nut-row class="colFlex mt16 wbg">
      <nut-radiogroup v-model="payMethod" class="wd100">
        <nut-row class="bothCenter opd16 vpd20 box">
          <nut-col :span="4" class="bothCenter">
            <img src="https://cdn.waityou.online/801b9301-ac26-ad59-ef72-134c5b20b882.svg"
                 class="sqr30 brd20">
          </nut-col>
          <nut-col :span="16" class="colFlex">
            <span>微信付款</span>
          </nut-col>
          <nut-col :span="4" class="rightCenter">
            <nut-radio label="wechat"></nut-radio>
          </nut-col>
        </nut-row>
        <div class="divider"></div>
        <nut-row class="bothCenter opd16 vpd20 box">
          <nut-col :span="4" class="bothCenter">
            <img src="https://cdn.waityou.online/4a41e165-fcb0-eace-c626-5aae10de275b.svg"
                 class="sqr30 brd20">
          </nut-col>
          <nut-col :span="16" class="colFlex">
            <span>支付宝付款</span>
          </nut-col>
          <nut-col :span="4" class="rightCenter">
            <nut-radio label="alipay"></nut-radio>
          </nut-col>
        </nut-row>
        <div class="divider"></div>
        <nut-row class="bothCenter opd16 vpd20 box">
          <nut-col :span="4" class="bothCenter">
            <img src="https://cdn.waityou.online/a8cb9c10-2b61-70ab-62bf-c0ae7d51d56b.svg"
                 class="sqr30 brd20">
          </nut-col>
          <nut-col :span="16" class="colFlex">
            <span>余额支付(¥{{ balance.toFixed(2) }})</span>
          </nut-col>
          <nut-col :span="4" class="rightCenter">
            <nut-radio label="balance"></nut-radio>
          </nut-col>
        </nut-row>
      </nut-radiogroup>
    </nut-row>
    <nut-row class="bothCenter wd100 box pd20">
      <nut-button type="warning" shape="rect" size="large" class="wd100 brd10"
                  @click="confirmPay()">确认支付 ¥{{ order.amt ? (order.amt / 100.0).toFixed(2) : '-' }}
      </nut-button>
    </nut-row>
  </div>
  <nut-popup :style="{ padding: '30px 50px',width:'50vw',borderRadius:'10px' }"
             v-model:visible="smsVerifyVisible">
    <nut-row class="colFlex bothCenter">
      <span>短信验证码</span>
      <nut-input placeholder="请输入短信验证码" input-align="center" v-model="smsCode" class="mt16"></nut-input>
      <nut-row class="mt16 bothCenter">
        <nut-button type="primary" style="width: 100px;" @click="submitSmsVerify">确认</nut-button>
      </nut-row>
    </nut-row>
  </nut-popup>
</template>

<script>
import api from "@/api";
import {Toast} from "@nutui/nutui";

export default {
  name: "LianLianPayView",
  data() {
    return {
      orderId: this.$route.params.orderId,
      order: {},
      payMethod: 'wechat',
      balance: 0,
      balancePayConfig: null,
      smsVerifyVisible: false,
      smsCode: null,
      smsToken: null,
    }
  },
  methods: {
    init() {
      api.getOpenSaleOrder({orderId: this.orderId})
          .then(ret => {
            this.order = ret;
          })
      api.getBalancePayConfig({orderId: this.orderId})
          .then(ret => {
            this.balance = ret.balance;
            this.balancePayConfig = ret;
          })
    },
    submitSmsVerify() {
      api.submitPaySmsVerify({
        token: this.smsToken,
        code: this.smsCode,
        orderId: this.orderId,
      }).then(() => {
        this.smsVerifyVisible = false;
        Toast.success('支付成功');
        window.location.href = this.order.redirectUrl + '?orderId=' + this.orderId;
      })
    },
    confirmPay() {
      if (this.payMethod === 'wechat') {
        this.confirmWechatPay()
      } else if (this.payMethod == 'alipay') {
        this.$router.replace('/alipay/' + this.orderId)
      } else if (this.payMethod == 'balance') {
        if (this.balancePayConfig == null || this.balance < this.order.amt/100.0) {
          Toast.fail('余额不足请选择其他方式')
          return
        }
        window.lianlianpay.invokePasswordControl({
          /**
           * passwordScene 使用场景
           * setting_password-设置密码
           * change_password-修改密码
           * bind_card_password-换绑卡
           * cashout_password-提现
           * pay_password-支付
           */
          passwordScene: 'pay_password',
          oidPartner: this.balancePayConfig.mchId, // 商户号
          'userId': this.balancePayConfig.userId, // 用户号
          passwordElementToken: this.balancePayConfig.token, // 向服务端请求生成的 token
          env: 'production', // 默认 production-生产
          styles: { // 样式集合
            themeColor: '#0E59F0', // 主题颜色（按钮等）
          }
        }, (res) => {
          this.confirmBalancePay(res.data.password, res.data.randomKey)
        })
      }
    },
    confirmBalancePay(password, randomKey) {
      Toast.loading('请稍等...')
      let thiz = this;
      api.confirmInnerLianLianPay({
        orderId: this.orderId,
        method: this.payMethod,
        password: password,
        randomKey: randomKey,
      }).then(ret => {
        Toast.hide()
        console.log('支付结果', ret)
        if (!ret.smsVerify) {
          Toast.loading('请稍等...')
          window.location.href = thiz.order.redirectUrl + '?orderId=' + thiz.orderId;
          return
        }
        this.smsToken = ret.token;
        this.smsVerifyVisible = true;
      })
    },
    confirmWechatPay() {
      Toast.loading('请稍等...')
      let thiz = this;
      api.confirmInnerLianLianPay({
        orderId: this.orderId,
        method: this.payMethod,
      }).then(ret => {
        Toast.hide()
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke(
            'getBrandWCPayRequest', ret.metadata,
            function () {
              Toast.loading('请稍等...')
              window.location.href = thiz.order.redirectUrl + '?orderId=' + thiz.orderId;
            });
      })
    }
  },
  mounted() {
    this.init()
    document.title = '收银台'
  }
}
</script>

<style lang="scss" scoped>
.LianLianPayViewContainer {
  display: flex;
  flex-direction: column;
  background-color: rgba(222, 222, 222, 0.2);
  min-height: 100vh;
}
</style>